import { Link } from 'react-router-dom';
import { TYPE } from 'react-toastify/dist/utils';
import { ROUTES } from '../routing/routes';
import { typesDocuments } from '../types/documents';
import {
  TypeNotification,
  TYPES_NOTIFICATIONS
} from '../types/menu-notifications';
import { prettyDate } from './strings';

enum Type {
  TYPE_ADD = 'add',
  TYPE_RECURRENT = 'recurrent'
}

const computeLitigationsMessage = (notification: any) => {
  if (
    notification.subcategory === typesDocuments.LITIGATION &&
    notification.type === Type.TYPE_ADD
  ) {
    return `${notification.addedBy} a adăugat dosarul cu numarul ${notification.litigation.uniqueFileNumber} la litigii.`;
  }

  if (
    notification.subcategory === typesDocuments.LITIGATION_DOCUMENT &&
    notification.type === Type.TYPE_ADD
  ) {
    return `${notification.addedBy} a adăugat documentul ${notification.litigationDocument.name} la dosarul ${notification.litigation.uniqueFileNumber}.`;
  }

  if (notification.subcategory === typesDocuments.LITIGATION_TERM) {
    return `Dosarul ${
      notification.litigation.uniqueFileNumber
    } are termenul pe data de ${prettyDate(notification.litigation.term)}. ${
      notification.daysBefore === 0
        ? 'A expirat astăzi.'
        : notification.daysBefore > 0
        ? `Au mai ramas ${notification.daysBefore} zile.`
        : `A expirat de ${-notification.daysBefore} zile.`
    }`;
  }

  if (
    notification.subcategory === typesDocuments.LITIGATION_DOCUMENT &&
    notification.type === Type.TYPE_RECURRENT
  ) {
    return `Documentul ${notification.litigationDocument.name} din dosarul ${
      notification.litigation.uniqueFileNumber
    } are termenul pe data de ${prettyDate(
      notification.litigationDocument.deadline
    )}. ${
      notification.daysBefore === 0
        ? 'A expirat astăzi.'
        : notification.daysBefore > 0
        ? `Au mai ramas ${notification.daysBefore} zile.`
        : `A expirat de ${-notification.daysBefore} zile.`
    }`;
  }
};

const computeAuditMessage = (notification: any) => {
  if (notification.category === typesDocuments.AUDIT) {
    let period = `luna ${notification.audit.startMonth}`;
    if (notification.audit.endMonth) {
      period = `perioada ${notification.audit.startMonth} - ${notification.audit.endMonth}`;
    }
    return `In ${period} ${
      notification.audit.year
    }  conform PROGRAMULUI DE ACTIVITATE AL CURTII DE CONTURI, ${
      notification.audit.department
    } va avea loc auditul Curtii de Conturi cu urmatoarea misiune: ${
      notification.audit.mission
    }. ${
      notification.daysBefore === 0
        ? 'Va afea loc in aceasta luna'
        : `Au mai ramas ${notification.daysBefore} zile.`
    }`;
  }
};

const computeDocumentsMessage = (
  user: string,
  type: string,
  date: string,
  option: any
) => {
  switch (type) {
    case typesDocuments.LEGISLATION:
      return `${user} a adăugat documentul ${option.legislation?.name} la legislatie.`;
    case typesDocuments.ADMIN_LEGISLATION:
      return `Administratorul ${user} a adăugat documentul ${option.legislation?.name} la legislatie.`;
    case typesDocuments.CCR_RAPORT:
      return `${user} a adăugat un raport CCR nou: ${option.ccrReport?.name}.`;
    case typesDocuments.FOLLOWUP_CCR_RAPORT:
      return `${user} a adăugat un raport de followup: ${option.followupCcrReport?.name}.`;
    case typesDocuments.ADDITIONAL_DOCUMENT:
      return `${user} a adăugat un document aditional: ${option.additionalDocument?.name}.`;
    // return `${user} a adăugat un document de modificare masura pentru masura ${name} din decizia cu numarul ${name}.`;
    case typesDocuments.DECISION_DOCUMENT:
      return `${user} a adăugat un document la o monitorizare.`;
  }
};

const computeDescriptionMessage = (type: string, option: any) => {
  switch (type) {
    case typesDocuments.LEGISLATION:
      return ``;
    case typesDocuments.ADMIN_LEGISLATION:
      return ``;
    case typesDocuments.CCR_RAPORT:
      return ``;
    case typesDocuments.FOLLOWUP_CCR_RAPORT:
      return ``;
    case typesDocuments.ADDITIONAL_DOCUMENT:
      return ``;
    // return `${user} a adăugat un document de modificare masura pentru masura ${name} din decizia cu numarul ${name}.`;
    case typesDocuments.DECISION_DOCUMENT:
      return `A adăugat măsura cu numărul ${option.decisionMeasure?.number} la monitorizarea cu numărul ${option.decision?.number}.`;
  }
};

const computeMeasurementsMessage = (
  decisionNumber: string,
  number: string,
  deadline: string,
  daysLeft: number
) =>
  `Măsura ${decisionNumber} din monitorizarea ${number} are termenul pe data de ${prettyDate(
    deadline
  )}. ${
    daysLeft === 0
      ? 'A expirat astăzi.'
      : daysLeft > 0
      ? `Au mai ramas ${daysLeft} zile.`
      : `A expirat de ${-daysLeft} zile.`
  }`;

const computeControlsMessage = (
  year: string,
  remaining: string | number,
  period: string
) =>
  period
    ? remaining < 0
      ? `În perioada ${period.toLowerCase()}, ${year}, acum ${-remaining} zile, ați primit un control din partea curții de conturi.`
      : `În perioada ${period.toLowerCase()}, ${year}, în ${remaining} zile, veți primi un control din partea curții de conturi.`
    : '';

const computeActionsMessage = (judge: string, fileNo: string) =>
  `Dosarul ${fileNo}`;

const computeJudgeDecisionsMessage = () => 'Notificare hotărâre';

const extractInfo = (notificationType: TypeNotification, option: any) => {
  switch (notificationType.key) {
    case TYPES_NOTIFICATIONS.AUDITS: {
      return {
        department: option.department,
        mission: option.mission,
        startMonth: option.startMonth,
        endMonth: option.endMonth,
        year: option.year
      };
    }
    case TYPES_NOTIFICATIONS.LITIGATIONS: {
      return {
        addedBy: option.addedBy,
        type: option.subcategory,
        date: option.litigation.litigationDocument
          ? option.litigation.litigationDocument.deadline
          : option.litigation.term,
        name: option.documentName,
        daysLeft: option.daysBefore
      };
    }
    case TYPES_NOTIFICATIONS.DOCUMENTS:
      return {
        addedBy: option.addedBy,
        type: option.type,
        date: option.documentDateOrigin,
        name: option.documentName
      };
    // case TYPES_NOTIFICATIONS.ACTIUNI:
    //   return {
    //     judge: option.judge,
    //     uniqueFileNumber: option.number
    //   };
    case TYPES_NOTIFICATIONS.HOTARARI:
      return {};
    case TYPES_NOTIFICATIONS.CONTROALE:
      return {
        period: option.period,
        year: option.year,
        daysLeft: option.daysLeft
      };
    case TYPES_NOTIFICATIONS.MASURI:
      return {
        decisionNumber: option.decisionNumber,
        number: option.number,
        deadline: option.deadline,
        daysLeft: option.daysLeft
      };
    default:
      return null;
  }
};

const mapTypeToMessage = (notificationType: TypeNotification, option: any) => {
  const args = extractInfo(notificationType, option);

  if (args) {
    switch (notificationType.key) {
      // case TYPES_NOTIFICATIONS.ACTIUNI:
      //   return computeActionsMessage(args.judge, args.uniqueFileNumber);
      case TYPES_NOTIFICATIONS.AUDITS:
        return computeAuditMessage(option);
      case TYPES_NOTIFICATIONS.LITIGATIONS:
        return computeLitigationsMessage(option);
      case TYPES_NOTIFICATIONS.DOCUMENTS:
        return computeDocumentsMessage(
          args.addedBy,
          args.type,
          args.date,
          args.name
        );
      case TYPES_NOTIFICATIONS.MASURI:
        return computeMeasurementsMessage(
          args.decisionNumber,
          args.number,
          args.deadline,
          args.daysLeft
        );
      case TYPES_NOTIFICATIONS.HOTARARI:
        return computeJudgeDecisionsMessage();
      case TYPES_NOTIFICATIONS.CONTROALE:
        return computeControlsMessage(args.year, args.daysLeft, args.period);
      default:
        return '';
    }
  }
};

const mapDetails = (notificationType: TypeNotification, option: any) => {
  switch (option.subcategory) {
    case typesDocuments.LEGISLATION:
      return <Link to={{ pathname: ROUTES.LEGISLATION }}>Detalii</Link>;
    case typesDocuments.ADMIN_LEGISLATION:
      return <Link to={{ pathname: ROUTES.LEGISLATION }}>Detalii</Link>;
    case typesDocuments.CCR_RAPORT:
      return <Link to={{ pathname: ROUTES.REPORTS }}>Detalii</Link>;
    case typesDocuments.FOLLOWUP_CCR_RAPORT:
      return <Link to={{ pathname: ROUTES.REPORTS }}>Detalii</Link>;
    case typesDocuments.ADDITIONAL_DOCUMENT:
      return <Link to={{ pathname: ROUTES.REPORTS }}>Detalii</Link>;
    // return `${user} a adăugat un document de modificare masura pentru masura ${name} din decizia cu numarul ${name}.`;
    case typesDocuments.DECISION_DOCUMENT:
      return (
        <Link
          to={{
            pathname: ROUTES.DECISION,
            state: { id: option.decision?.id, editingMode: true }
          }}
        >
          Detalii
        </Link>
      );
  }
};

export {
  computeAuditMessage,
  computeDocumentsMessage,
  computeMeasurementsMessage,
  computeControlsMessage,
  computeActionsMessage,
  computeJudgeDecisionsMessage,
  mapTypeToMessage,
  extractInfo,
  mapDetails,
  computeDescriptionMessage
};
